import React, { useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Col, Form, Row, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { paramCase } from 'change-case';
import Loader from '../../components/Loader';
import { setCourseItem } from '../store/action/CourseAction';
import { txtRHF } from '../../utils/texts';
import '../../_metronic/_assets/sass/custom/_create-course.scss';
import Toast from '../../components/Toast';

const CreateCourse = props => {
  let { match, history } = props;

  // const permission = useSelector((state) => state.permissionSelected.data);
  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let { courseItem, isLoading, error } = useSelector(state => state.course);

  const { register, handleSubmit, errors, setError } = useForm({
    mode: 'onChange',
  });

  const dispatch = useDispatch();

  const onSubmit = async data => {
    let roleName = selectedRole.name;
    if (roleName === 'course_creator') {
      roleName = 'course-creator';
    }

    dispatch(setCourseItem({ ...data, organization_id: selectedOrg.id }, roleName)).then(function(r) {
      console.log(r);
      if (r?.id) {
        history.push(`/courses/${r.id}`);
      }
    });
  };

  // useEffect(() => {
  //   // if (permission) {
  //   if (selectedRole.name === 'admin') history.push('/');
  //   // }
  // }, [permissions]);

  useEffect(() => {
    if (error) {
      Object.keys(error).forEach(item => {
        setError(item, 'manual', error[item][0]);
      });
    }
  }, [error]);

  return (
    <Fragment>
      <Loader visible={isLoading} />
      <div className="kt-portlet p-3">
        <div className="kt-portlet__body">
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                {permissions && (
                  <Row>
                    <Col xs={12}>
                      <Alert className={'custom-alert'}>
                        <div className="custom-alert-icon">
                          <i className="flaticon-questions"></i>
                        </div>
                        <p>
                          درحال حاضر شما برای سازمان
                          <span className={'custom-alert-obj'}> {selectedOrg.name} </span>
                          در نقش
                          <span className={'custom-alert-obj'}> {selectedRole.translated_name} </span>
                          دوره ایجاد می‌کنید.
                        </p>
                      </Alert>
                    </Col>
                  </Row>
                )}

                <Form.Group>
                  <Form.Label>
                    شماره دوره
                    <span className="ml-1">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="number"
                    ref={register({ required: 'این فیلد الزامی است' })}
                    className={`${errors.number && 'border border-danger'}`}
                    placeholder={'به عنوان مثال: CS100'}
                  />
                  {errors?.number && (
                    <div>
                      <span className="text-danger">{errors.number.message}</span>
                    </div>
                  )}
                  <Form.Label>
                    نام یکتایی که متمایز کننده دوره شما از سایر دوره های سازمان است.این قسمتی از آدرس دوره شما است، پس
                    باید بدون فاصله یا حروف خاص و به زبان انگلیسی باشد و قابل تغییر نیست.
                  </Form.Label>
                </Form.Group>

                <Form.Group>
                  <Form.Label>
                    اجرای دوره
                    <span className="ml-1">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="run"
                    id="run"
                    ref={register({ required: 'این فیلد الزامی است' })}
                    className={`${errors.run && 'border border-danger'}`}
                    placeholder={'به عنوان مثال: T1_2020'}
                  />
                  {errors?.run && (
                    <div>
                      <span className="text-danger">{errors.run.message}</span>
                    </div>
                  )}
                  <Form.Label>
                    ترمی که دوره شما در آن اجرا می‌شود. توجه: این قسمتی از آدرس دوره شما است، پس باید بدون فاصله یا حروف
                    خاص و به زیان انگلیسی باشد و قابل تغییر نیست.
                  </Form.Label>
                </Form.Group>

                <Button type="submit" variant="primary" className="btn-block my-4" name="submit">
                  ساخت دوره
                </Button>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </Fragment>
  );
};

export default CreateCourse;
